/** True when this document is nested. Cross-origin access to top may throw. */
export const isEmbeddedIframe = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.self !== window.top;
  } catch (_) {
    return true;
  }
};

/** ENG-1026 classroom iframe dest — not /new_help_center_public (parent shell). */
export const isSigningClassroomPath = (pathname: string): boolean => {
  return /^\/new_help_center(\/|_category|_tag)?(\/|$)/.test(pathname || '');
};

/** Iframe document that is the classroom SPA. Do not treat every iframe as classroom. */
export const isSigningClassroomIframe = (): boolean => {
  if (typeof window === 'undefined' || !isEmbeddedIframe()) {
    return false;
  }
  return isSigningClassroomPath(window.location.pathname);
};
